/**
 * En Çok Satan (özel ürün) rozetini sadece ürünün ilk görselinde gösterir.
 * Ürün kartları (card-gallery) ve ürün sayfası medya galerisi (media-gallery) için.
 */
const SLIDESHOW_SELECT = 'slideshow:select';

function setGallerySlideIndex(gallery, index) {
  if (!gallery) return;
  const hasCustomBadge =
    gallery.querySelector('.product-badges--custom-image') ||
    gallery.querySelector('.product-media-gallery__custom-badge');
  if (hasCustomBadge) {
    gallery.setAttribute('data-current-slide', String(index));
  }
}

function initGalleries() {
  // Ürün kartları (koleksiyon grid)
  document.querySelectorAll('.card-gallery .product-badges--custom-image').forEach((badge) => {
    const gallery = badge.closest('.card-gallery');
    if (gallery && !gallery.hasAttribute('data-current-slide')) {
      gallery.setAttribute('data-current-slide', '0');
    }
  });
  // Ürün sayfası medya galerisi
  document.querySelectorAll('media-gallery .product-media-gallery__custom-badge').forEach((badge) => {
    const gallery = badge.closest('media-gallery');
    if (gallery && !gallery.hasAttribute('data-current-slide')) {
      gallery.setAttribute('data-current-slide', '0');
    }
  });
}

document.addEventListener(SLIDESHOW_SELECT, (e) => {
  const slideshow = e.target?.closest?.('slideshow-component');
  if (!slideshow || e.detail?.index == null) return;
  const gallery = slideshow.closest('.card-gallery') || slideshow.closest('media-gallery');
  setGallerySlideIndex(gallery, e.detail.index);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleries);
} else {
  initGalleries();
}

document.addEventListener('shopify:section:load', initGalleries);
